import React from "react";
import { _goToBack, _openDrawer, _goToProfile } from "routers/helper";

import { StyleSheet, TouchableOpacity, View } from "react-native";
import HeaderLayout from "components/HeaderLayout";
import Button from "components/Button";
import Img from "components/img";

import css from "styles";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { sizes, colors, strings } from "assets/constants";
import { sn, verifyImageUrl } from "utils";
import Text from "components/Text";
import { logo } from "assets/images";
import Icon from "./Icon";
import tinycolor from "tinycolor2";

const TabHeader: React.FC = () => {
  const auth = useRecoilValue(authAtom);

  return (
    <HeaderLayout>
      <View style={styles.container}>
        <View style={styles.right}>
          {sn(true, true, true, false) && (
            <Button
              onPress={_openDrawer}
              bgColor={colors.white}
              circle={40}
              icon={{
                size: 22,
                type: "oct",
                name: "three-bars",
                color: auth?.company?.color,
              }}
            />
          )}

          <View>
            <Img
              source={logo.drawerLogo}
              style={{
                alignSelf: "flex-end",
                width: 70,
                height: 70 / 3.16,
              }}
            />
            <Text
              weight="extraBold"
              size={"sm"}
              // color={"#ff2500"}

              // color={"#888"}
            >
              {strings.management_system}
              {strings.selling_carpet}
            </Text>
          </View>
        </View>
        <View style={styles.left}>
          <TouchableOpacity
            onPress={_goToProfile}
            activeOpacity={sizes.tapOpacity}
          >
            <View
              style={{
                width: 50,
                height: 50,
                borderRadius: 1000,
                backgroundColor: colors.white,
                borderWidth: 2,
                borderColor: colors.theme + "15",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {auth.avatar ? (
                <Img style={styles.avatar} source={{ uri: auth?.avatar }} />
              ) : (
                <Icon
                  name="user"
                  size={30}
                  color={tinycolor(colors.theme).lighten(40).toString()}
                />
              )}
            </View>
          </TouchableOpacity>
        </View>
      </View>
    </HeaderLayout>
  );
};

export default TabHeader;

const styles = StyleSheet.create({
  container: { ...css.rRowCenterAlign, ...css.fitHeight, ...css.paddingH },

  right: { ...css.rRowContainerCenterAlign },

  left: { ...css.rowCenterAlign },

  avatar: {
    width: "100%",
    aspectRatio: 1,
    borderRadius: 1000,
    backgroundColor: colors.white,
  },
});
